import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';


class review6_2 extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                <Form className="boxreview">
                        <h1 className="textrandomtest1">Review แบบทดสอบ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คะแนนที่คุณได้</h3>  <br></br>
                           <h1 h5 align='center'>2</h1><br></br>
                           
                           <h5 className="textreview">1. เวลาใดที่กินเวลาน้อยที่สุด </h5><h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.อดีต</h5>
                           <h5 className="textreviewT">ข.ปัจจุบัน</h5>
                           <h5 className="textreviewF">ค.อนาคต</h5>
                           </Form>

                           <h5 className="textreview">2. ปีปกติสุรทินในระบบสุริยคติมีกี่วัน</h5>  <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.354 วัน</h5>
                           <h5 className="textreviewT">ข.365 วัน</h5>
                           <h5 className="textreviewF">ค.366 วัน</h5>
                        </Form>

                        <h5 className="textreview">3. ครึ่งหลังของพุทธศตวรรษที่ 25 หมายถึงช่วงเวลาใด</h5>  <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. พ.ศ. 2451–2500</h5>
                           <h5 className="textreviewF">ข. พ.ศ. 2450–2500</h5>
                           <h5 className="textreviewF">ค. พ.ศ. 2550–2600</h5>
                        </Form>

                        <h5 className="textreview">4. ทศวรรษ 1950 ในคริสต์ศักราชหมายถึงช่วงเวลาไหน</h5> <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5> 
                           <Form className="b1">
                           <h5 className="textreviewF">ก. ค.ศ. 1940–1950</h5>
                           <h5 className="textreviewT">ข. ค.ศ. 1950–1959</h5>
                           <h5 className="textreviewF">ค. ค.ศ. 1950–1960</h5>
                        </Form>

                        <h5 className="textreview">5. ในศิลาจารึกระบุว่า “เมืองสุโขทัยนี้ดี ในน้ำมีปลา ในนามีข้าว” อาจบ่งบอกว่า เมืองสุโขทัยน่าจะมีความอุดมสมบูรณ์ดี” ข้อความที่เป็นตัวเอน น่าจะเป็นขั้นตอนใด</h5>  <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5> 
                           <Form className="b1">
                           <h5 className="textreviewT">ก. การตีความหลักฐาน</h5>
                           <h5 className="textreviewF">ข. การประเมินข้อมูล</h5>
                           <h5 className="textreviewF">ค. การสังเคราะห์ข้อมูล</h5>
                        </Form>
                           
                           <p  h5 align='center'><Button href='/randomtest' color="#4fc3f7 light-blue lighten-2" >กลับหน้าหลัก</Button>{' '}</p>
                        </Form>
                       
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://www.facebook.com/few.connectfve">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default review6_2